export const DOMAINS = [
  {
    id: 1,
    key: 'uaeConsulting',
    name: 'uae-consulting'
  },
  {
    id: 2,
    key: 'sbt',
    name: 'sbt'
  },
  {
    id: 3,
    key: 'stg',
    name: 'stg'
  },
  {
    id: 4,
    name: 'localhost'
  }
]



// WEBPACK FOOTER //
// ./src/constants/domainListPlatform.js